import { useContext } from 'react';
import { BrandConfigurationContext } from './provider';
export const useBrandConfiguration = () => {
    const value = useContext(BrandConfigurationContext);
    if (value === null) {
        throw new Error('A brand configuration must be provided');
    }
    return value;
};
export const useShortBrand = () => useBrandConfiguration().shortBrand;
export const useFsrboGeneric = () => { var _a; return (_a = useBrandConfiguration().pages.fsrbo) === null || _a === void 0 ? void 0 : _a.generic; };
export const useFsrboRealEstate = () => { var _a; return (_a = useFsrboGeneric()) === null || _a === void 0 ? void 0 : _a.realEstateListing; };
export const useFsrboGenericContact = () => { var _a; return (_a = useFsrboGeneric()) === null || _a === void 0 ? void 0 : _a.contact; };
